import { render, staticRenderFns } from "./WapWXCW03BJRecordSXXBJ.vue?vue&type=template&id=a2c309d4&scoped=true&"
import script from "./WapWXCW03BJRecordSXXBJ.vue?vue&type=script&lang=js&"
export * from "./WapWXCW03BJRecordSXXBJ.vue?vue&type=script&lang=js&"
import style0 from "./WapWXCW03BJRecordSXXBJ.vue?vue&type=style&index=0&id=a2c309d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c309d4",
  null
  
)

export default component.exports